import { Link } from 'react-router-dom'

import { styled } from 'styled-system/jsx'

const MapShell = styled('div', {
  base: {
    position: 'relative',
    width: '100%',
    height: '640px',
    minHeight: '420px',
    borderRadius: 'lg',
    overflow: 'hidden',
    boxShadow: '0 12px 32px -16px rgba(128, 84, 255, 0.18)',
    border: '1.5px solid #E5E0F5',
  },
})

const MapPlaceholder = styled('div', {
  base: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    padding: '32px',
    textAlign: 'center',
    backgroundColor: '#FAF7FF',
    color: 'quickpass.inkSoft',
    fontFamily: 'body',
    fontSize: '14px',
  },
})

const MarkerButton = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '700',
    paddingX: '10px',
    paddingY: '5px',
    borderRadius: 'pill',
    border: '2px solid #FFFFFF',
    cursor: 'pointer',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.18)',
    transition: 'transform {durations.fast} {easings.appleStandard}',
    _hover: {
      transform: 'translateY(-2px) scale(1.05)',
    },
    color: '#FFFFFF',
    whiteSpace: 'nowrap',
  },
  variants: {
    tone: {
      great: { backgroundColor: '#1F8F57' },
      good: { backgroundColor: '#8054FF' },
      okay: { backgroundColor: '#D89E18' },
      low: { backgroundColor: '#8B7AA8' },
    },
    isSaved: {
      true: {
        outline: '3px solid #FFFFFF',
        outlineOffset: '-5px',
      },
    },
  },
})

const PopupRoot = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '240px',
  },
})

const PopupImage = styled('img', {
  base: {
    width: '100%',
    height: '120px',
    objectFit: 'cover',
    borderRadius: 'sm',
  },
})

const PopupImagePlaceholder = styled('div', {
  base: {
    width: '100%',
    height: '120px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '36px',
    color: 'quickpass.primary',
    opacity: '0.6',
    backgroundColor: '#F1ECFF',
    borderRadius: 'sm',
  },
})

const PopupTitle = styled(Link, {
  base: {
    fontFamily: 'display',
    fontSize: '14px',
    fontWeight: '700',
    color: 'quickpass.ink',
    textDecoration: 'none',
    letterSpacing: '-0.2px',
    overflow: 'hidden',
    lineClamp: '2',
    _hover: { color: 'quickpass.primary' },
  },
})

const PopupMeta = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: 'quickpass.inkSoft',
    margin: '0',
  },
})

const PopupPrice = styled('p', {
  base: {
    fontFamily: 'display',
    fontSize: '15px',
    fontWeight: '700',
    color: 'quickpass.primary',
    margin: '0',
  },
})

const PopupActions = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    marginTop: '4px',
  },
})

const PopupActionButton = styled(Link, {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '600',
    paddingX: '10px',
    paddingY: '5px',
    borderRadius: 'pill',
    border: '1.5px solid #E5E0F5',
    backgroundColor: '#FFFFFF',
    color: 'quickpass.ink',
    cursor: 'pointer',
    _hover: { borderColor: 'quickpass.primary', color: 'quickpass.primary' },
  },
  variants: {
    isPrimary: {
      true: {
        backgroundColor: 'quickpass.primary',
        color: '#FFFFFF',
        borderColor: 'transparent',
        _hover: { color: '#FFFFFF', opacity: '0.9' },
      },
    },
  },
})

const MissingCoordsBanner = styled('p', {
  base: {
    position: 'absolute',
    bottom: '12px',
    left: '12px',
    right: '12px',
    margin: '0',
    paddingX: '12px',
    paddingY: '8px',
    backgroundColor: 'rgba(255, 255, 255, 0.94)',
    borderRadius: 'pill',
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '600',
    color: 'quickpass.inkSoft',
    textAlign: 'center',
    backdropFilter: 'blur(6px)',
    zIndex: '5',
  },
})

export {
  MapShell,
  MapPlaceholder,
  MarkerButton,
  PopupRoot,
  PopupImage,
  PopupImagePlaceholder,
  PopupTitle,
  PopupMeta,
  PopupPrice,
  PopupActions,
  PopupActionButton,
  MissingCoordsBanner,
}
